// extracted by mini-css-extract-plugin
module.exports = {"subjectCard":"subjectInfoCard_subjectCard__2AEbP","customerNumber":"subjectInfoCard_customerNumber__37zDp"};